__webpack_require__.tu = function(url) { return __webpack_require__.tt().createScriptURL(url); };